import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { UpdateDisciplinesRequestErrorProps } from './types';
import { UpdateWorkPackageDisciplineError } from '@bechtel/types';

const getErrorMessage = (error: UpdateDisciplinesRequestErrorProps['updateDisciplinesError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  } else if (error == UpdateWorkPackageDisciplineError.INVALID_DISCIPLINE_PROVIDED)
    return <Trans>Invalid discipline provided.</Trans>;
};

const UpdateDisciplinesRequestErrorModal: FC<UpdateDisciplinesRequestErrorProps> = ({
  updateDisciplinesError,
  close,
}) => {
  return (
    <Modal
      visible
      size={ModalSize.DEFAULT}
      data-testid="update-disciplines-request-error"
      style={{ width: '552px', height: '275px' }}
    >
      <ModalHeader title={t`Update Disciplines Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(updateDisciplinesError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
export default UpdateDisciplinesRequestErrorModal;
